import { UAParser } from "ua-parser-js";

export const detectDeviceType = (): "android" | "iphone" | "windows" | "other" => {
  const parser = new UAParser();
  const os = parser.getOS().name?.toLowerCase();

  if (os === "android") {
    return "android";
  } else if (os === "ios") {
    return "iphone";
  } else if (os === "windows") {
    return "windows";
  }
  return "other";
};

/**
 * Detects device form factor: mobile, tablet, or desktop
 */
export const getDeviceFormFactor = (): "mobile" | "tablet" | "desktop" => {
  const parser = new UAParser();
  const device = parser.getDevice();
  const ua = navigator.userAgent;
  const platform = navigator.platform;
  const screenWidth = window.innerWidth;

  // Breakpoints consistent with AdRendererOptimize.tsx
  const mobileBreakpoint = 768; // Mobile: < 768px
  const tabletBreakpoint = 1025; // Tablet: >= 768px and < 1025px

  // Special check for iPadOS (iPadOS 13+ often presents as Macintosh/Desktop)
  const isiPadOS =
    (platform === "MacIntel" && navigator.maxTouchPoints > 1) ||
    /iPad/i.test(ua) ||
    (ua.includes("Macintosh") && navigator.maxTouchPoints > 1);

  // 1. Check by UA/Platform (More reliable for specific devices)
  if (isiPadOS || device.type === "tablet") {
    return "tablet";
  }

  if (device.type === "mobile") {
    return "mobile";
  }

  // 2. Check by screen size (consistent with UI breakpoints)
  // If UAParser didn't catch it, or for responsive behavior
  if (screenWidth >= tabletBreakpoint) {
    return "desktop";
  } else if (screenWidth >= mobileBreakpoint) {
    return "tablet";
  }

  // 3. Last fallback: check UA keywords if UAParser missed them
  if (/(tablet|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return "mobile";
  }

  return "mobile"; // Default to mobile for small screens
};

/**
 * Returns the appropriate destination URL based on the device type.
 * Priority: 
 * - Desktop: destinationUrlDesktop -> destinationUrl
 * - Tablet: destinationUrlTablet -> destinationUrl
 * - Mobile: destinationUrl
 */
export const getRedirectUrl = (
  destinationUrl?: string,
  destinationUrlTablet?: string,
  destinationUrlDesktop?: string
): string | undefined => {
  const formFactor = getDeviceFormFactor();

  console.log("--- Device Redirect Diagnostic ---");
  console.log("Detected Form Factor:", formFactor);
  console.log("Available URLs:", {
    mobile: destinationUrl,
    tablet: destinationUrlTablet,
    desktop: destinationUrlDesktop
  });

  let redirectUrl = destinationUrl;

  if (formFactor === "desktop" && destinationUrlDesktop) {
    console.log("Choice: Desktop specific URL");
    redirectUrl = destinationUrlDesktop;
  } else if (formFactor === "tablet" && destinationUrlTablet) {
    console.log("Choice: Tablet specific URL");
    redirectUrl = destinationUrlTablet;
  } else {
    console.log("Choice: Default/Mobile URL");
    redirectUrl = destinationUrl;
  }

  console.log("Final Selected Base URL:", redirectUrl);
  console.log("----------------------------------");

  return redirectUrl;
};